'use strict';
let xeScript = {
    data() {
        return{
            deferVisible: false,
            applyReturnShow: false,
            xeList: [],
            xeDetailShow: false,
            xeForm: {}
        }
    },
    methods: {
        //提箱单详情
        detailsXeModal(data){
            this.xeForm = data;
            this.xeDetailShow = true;
        },
        downloadXeFile(data){
            let fileUrl;
            if(this.xeFileMap[data.MASTER_ID + '20011001']){
                fileUrl = this.xeFileMap?.[data.MASTER_ID + '20011001']?.FILE_NAME;
            }else {
                fileUrl = this.xeFileMap?.[data.MASTER_ID + '20011002']?.FILE_NAME;
            }
            this.$Dolphin.download(this.$t('putBoxVoucher'), this.$Dolphin.path.filePath + fileUrl)
            /*let condition = {
                "SYS_TYPE":"20011003",
                "TARGET_CATE":"20021007",
                "TARGET_TYPE":"20071002",
                "TARGET_ID": data.MASTER_ID
            }
            this.$h5Api({
                type: '2021',
                data: [condition],
            }).then(({data}) => {
                this.$Dolphin.download('放箱凭证', this.$Dolphin.path.filePath + data?.FILE_LIST?.[0]?.FILE_NAME)
            })*/
        },
        downTemplateXeFile() {
            if(this.$i18n.locale === 'ru'){
                this.$Dolphin.download(this.$t('leaseTakeBoxTemplate'), this.$Dolphin.path.contextPath +'/static/importTemplate/emptyAccess/空箱提取(Забор порожних).xlsx')
            } else if (this.$i18n.locale === 'en') {
                this.$Dolphin.download(this.$t('leaseTakeBoxTemplate'), this.$Dolphin.path.contextPath +'/static/importTemplate/emptyAccess/空箱提取(Pick-up empty containers).xlsx')
            } else {
                this.$Dolphin.download(this.$t('leaseTakeBoxTemplate'), this.$Dolphin.path.contextPath +'/static/importTemplate/emptyAccess/空箱提取.xlsx')
            };
        },
    },
    created() {
    }
};

export default xeScript